import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from '../images/logo.svg';
import logoDark from '../images/logo-dark.svg';
import logoSm from '../images/logo-sm.svg';
import { Button } from "react-bootstrap";
import {
  LayoutDashboard,
  Briefcase,
  Receipt,
  Users,
  Bell,
  Share2,
  LogOut,
  Palette,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";

const Sidebar = ({ isCollapsed, toggleMainSidebar }) => {

  const [isDark, setIsDark] = useState(false);
    useEffect(() => {
      const interval = setInterval(() => {
        const savedTheme = localStorage.getItem("theme");
        setIsDark(savedTheme === "dark");
      }, 100);
  
      return () => clearInterval(interval);
  }, []);

  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    if (!isCollapsed) {
      document.body.classList.add("sidebar-activated");
    } else {
      document.body.classList.remove("sidebar-activated");
    }
    return () => {
      document.body.classList.remove("sidebar-activated");
    };
  }, [isCollapsed]);

    

  const menuItems = [
    { path: "/dashboard", label: "Dashboard", icon: <LayoutDashboard strokeWidth={1.5} size={20} /> },
    { path: "/my-assets", label: "Assets", icon: <Briefcase strokeWidth={1.5} size={20} /> },
    { path: "/my-liability", label: "Liabilities", icon: <Receipt strokeWidth={1.5} size={20} /> },
    { path: "/shared-with-you", label: "Shared With You", icon: <Share2 strokeWidth={1.5} size={20} /> },
    { path: "/collaborators", label: "Collaborators", icon: <Users strokeWidth={1.5} size={20} /> },
    { path: "/notifications", label: "Notifications", icon: <Bell strokeWidth={1.5} size={20} /> },
  ];

  return (
    <div className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <div>
        <div className="sidebar-header d-flex align-items-center px-4 py-5 mb-3">
          <Link to="/dashboard" className="header-logo text-decoration-none">
            <img className="logo-full" src={isDark ? logoDark : logo} alt="logo" />
            <img className="logo-sm" src={logoSm} alt="logo" />
          </Link>
        </div>
        <ul className="nav flex-column">
          {menuItems.map((item, index) => (
            <li key={index} className="nav-item" title={isCollapsed ? item.label : ""}>
              <Link to={item.path} className={`nav-link d-flex align-items-center ${isActive(item.path) ? "active" : ""}`} onClick={() => document.body.classList.remove("menu-opened")}>
                <span className="icon me-2">{item.icon}</span>
                <span className="link-text">{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <button
        type="button"
        onClick={toggleMainSidebar}
        className="toggle-sidebar-btn"
        aria-label="Toggle sidebar"
      >
        {isCollapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
      </button>
    </div>
  );
};

export default Sidebar;